import { ScrollableContents } from '@!/Store/Common/components/ScrollableList'

/* 横スクロール型の新着コミックス */
export const ScrollableNewBookList = ({ newBooks, genreTabName }) => {
  const sectionTitle = '待望の新着コミックス'
  const baseUrl = '/store/new_books'
  const url = !genreTabName ? baseUrl : `${baseUrl}?genre_tab_name=${genreTabName}`
  const gtmClick = genreTabName ? `${genreTabName}_new` : `home_new`

  return <ScrollableContents contents={newBooks} sectionTitle={sectionTitle} url={url} gtmClick={gtmClick} />
}
